import { flickitySliderBySelector } from '@molecules/flickity-continuous-slider';

export const initGuide = () => {
  if (document.querySelector('.guide-article')) {
    flickitySliderBySelector('.content-blocks__item--logos');
  }
};
